<!-- class="nav-tabs-second" -->

<tabset type="tabs" class="tabs-animated tabs-nav-first tabs-animated-shadow mb-5">
    <tab id="AgedStatusReportTab">
        <ng-template tabHeading>
            <span>AR Aged Report</span>
        </ng-template>

        <div class="card card-box mt-1">
            <div class="card-header">
                <div class="display-5  card-header--title font-weight-bold" style="font-size: 16px;">
                    AR Aged Report
                </div>
                <!-- <div class="card-header--actions">
                                <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                                    <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary" (click)="showFilter1()"
                                        dropdownToggle type="button">
                                        <span class="btn-wrapper--label">Filters</span>
                                        <span class="btn-wrapper--icon">
                                            <fa-icon *ngIf="!isShow" [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1">
                                            </fa-icon>
                                            <fa-icon *ngIf="isShow" [icon]="['fas', 'chevron-up']" class="opacity-8 font-size-xs ml-1">
                                            </fa-icon>
                                        </span>
                                    </button>
                                </div>
                                <button (click)="exportExcel()" tooltip="Excel" id="excelBtn"
                                    class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                    type="button">
                                    <fa-icon [icon]="['far', 'file-excel']" class="h5 d-block mb-2 mt-1 text-primary btn-wrapper--icon">
                                    </fa-icon>
                                </button>
                                <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                                    <button tooltip="Refresh" (click)="onReset1()"
                                        class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                        type="button">
                                        <span class="btn-wrapper--icon">
                                            <i class="ion-md-sync"></i>
                                        </span>
                                    </button>
                                </div>
                            </div> -->
            </div>

            <div class="card-body">
                <div>



                    <div class="justify-content-between">

                        <!-- <div *ngIf="isShow">
                            <form [formGroup]="filters_form1" novalidate>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>Reservation From Date</label>
                                            <div class="input-group input-group-lg">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                        </fa-icon>
                                                    </span>
                                                </div>
                                                <input [bsConfig]="{
                                                    containerClass: 'theme-primary',
                                                    isAnimated: true,
                                                    customTodayClass: 'custom-today-class'
                                                  }" bsDatepicker formControlName="startdate1" class="form-control"
                                                    placeholder="Select date" type="text" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>Reservation To Date</label>
                                            <div class="input-group input-group-lg">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                        </fa-icon>
                                                    </span>
                                                </div>
                                                <input [bsConfig]="{
                                                    containerClass: 'theme-primary',
                                                    isAnimated: true,
                                                    customTodayClass: 'custom-today-class'
                                                  }" bsDatepicker formControlName="enddate1" class="form-control"
                                                    placeholder="Select date" type="text" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group pt-4">
                                            <button class="btn  mt-2 btn-sm btn-block btn-primary btn-square"
                                                type="button" (click)="onFilter1(filters_form1.value)">
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group pt-4">
                                            <button class="btn btn-sm mt-2  btn-block btn-primary btn-square"
                                                type="button" (click)="onReset1()">
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="d-flex justify-content-between pb-3">
                            <div class="search-wrapper">
                                <span class="icon-wrapper text-black">
                                    <fa-icon [icon]="['fas', 'search']"></fa-icon>
                                </span>
                                <input type="text" class="form-control form-control-sm rounded-pill"
                                    placeholder="ResID, Station, Concierge" [ngModelOptions]="{ standalone: true }"
                                    [(ngModel)]="searchText1" />
                            </div>
                        </div> -->

                        <div *ngIf="agedStatusReport | tsearch: searchText; let filtereddayBeforeData">
                            <div class="table-responsive table-scroll">
                                <table id="reportAgedReport"
                                    class="table table-hover table-striped table-bordered text-nowrap mb-3"
                                    [mfData]="filtereddayBeforeData" #mf="mfDataTable" [mfRowsOnPage]="100">
                                    <thead>
                                        <tr>
                                            <th class="bg-white text-left">
                                                <mfDefaultSorter by="RESID">Res ID</mfDefaultSorter>
                                            </th>
                                            <th class="bg-white text-left" style="z-index: 1;">Promotional Contract</th>
                                            <th class="bg-white text-left">Res Type</th>
                                            <th class="bg-white text-left">Res Start Date</th>
                                            <th class="bg-white text-left">Res Creation Date</th>
                                            <th class="bg-white text-left">Station</th>
                                            <th class="bg-white text-left">Currency</th>
                                            <th class="bg-white text-left">Customer Bill To (Company Name)</th>
                                            <th class="bg-white text-left">Customer Name </th>
                                            <th class="bg-white text-left">Contact Phone</th>
                                            <th class="bg-white text-left">Transaction Type</th>
                                            <th class="bg-white text-left">Sub Total</th>
                                            <th class="bg-white text-left">Tax</th>
                                            <th class="bg-white text-left">Total </th>
                                            <th class="bg-white text-left">Invoice Receipt ID</th>
                                            <th class="bg-white text-left">Net Terms</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let greet of mf.data let i=index;">
                                            <td class="text-left">
                                                {{greet.RESID}}
                                            </td>
                                            <td class="text-left">
                                                <div class="custom-checkbox custom-control d-flex" *ngIf="greet?.is_capital_one">
                                                    Capital One
                                                </div>
                                            </td>
                                            <td class="text-left">
                                                {{greet.RES_TYPE}}
                                            </td>
                                            <td class="text-left">
                                                {{getDate(greet.STARTDT)}}
                                            </td>
                                            <td class="text-left ">
                                                <span>{{getDate(greet.RESCREATIONDT)}}
                                                </span>
                                            </td>
                                            <td class="text-left">
                                                {{greet.STATION}}
                                            </td>
                                            <td class="text-left">
                                                {{greet.CURRENCY_FLAG}}
                                            </td>
                                            <td class="text-left">
                                                {{greet.COMPANY_NAME}}
                                            </td>
                                            <td class="text-left ">
                                                {{greet.CONTACT_NAME}}
                                            </td>
                                            <td class="text-left ">
                                                {{greet.CONTACT_PHONE}}
                                            </td>
                                            <td class="text-left ">
                                                <span>{{greet.TRANSACTION_TYPE}}
                                                </span>
                                            </td>
                                            <td class="text-left ">
                                                <span>{{greet.TRANSACTION_SUBTOTAL}}
                                                </span>
                                            </td>
                                            <td class="text-left">
                                                {{greet.TRANSACTION_TAXES}}
                                            </td>
                                            <td class="text-left ">
                                                <span>{{greet.TRANSACTION_TOTAL}}
                                                </span>
                                            </td>
                                            <td class="text-left ">
                                                <span>{{greet.INVOICE_RECEIPT_ID}}
                                                </span>
                                            </td>
                                            <td class="text-left">
                                                {{greet.NET_TERMS}}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="9">
                                                <span class="font-weight-bold">Total Records: {{
                                                    filtereddayBeforeData.length
                                                    }}</span> &nbsp;&nbsp;&nbsp;
                                                <mfBootstrapPaginator [rowsOnPageSet]="[100, 200, 300]">
                                                </mfBootstrapPaginator>
                                            </td>
                                            <td colspan="6"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </tab>
    <tab id="TransactionReport">
        <ng-template tabHeading>
            <span>AR Transaction Report</span>
        </ng-template>
        <div>
            <div class="card card-box mt-2">
                <div class="card-header">
                    <div class="display-5  card-header--title font-weight-bold" style="font-size: 16px;">
                        AR Transaction Report
                    </div>
                    <div class="card-header--actions">
                        <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                            <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary"
                                (click)="showFilter()" dropdownToggle type="button">
                                <span class="btn-wrapper--label">Filters</span>
                                <span class="btn-wrapper--icon">
                                    <fa-icon *ngIf="!isShow" [icon]="['fas', 'chevron-down']"
                                        class="opacity-8 font-size-xs ml-1">
                                    </fa-icon>
                                    <fa-icon *ngIf="isShow" [icon]="['fas', 'chevron-up']"
                                        class="opacity-8 font-size-xs ml-1">
                                    </fa-icon>
                                </span>
                            </button>
                        </div>
                        <button (click)="exportExcel()" tooltip="Excel" id="excelBtn"
                            class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                            type="button">
                            <fa-icon [icon]="['far', 'file-excel']"
                                class="h5 d-block mb-2 mt-1 text-primary btn-wrapper--icon">
                            </fa-icon>
                        </button>
                        <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                            <button tooltip="Refresh" (click)="onRefresh()"
                                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                type="button">
                                <span class="btn-wrapper--icon">
                                    <i class="ion-md-sync"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card-body">

                    <div class=" justify-content-between">
                        <div *ngIf="isShow">
                            <form [formGroup]="filters_form" novalidate>
                                <div class="row">
                                    <!-- <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label> Reservation Type</label>
                                                        <ng-select formControlName="resType" [multiple]="true">
                                                            <ng-option value="AMEX">AMEX </ng-option>
                                                            <ng-option value="Retail">Retail </ng-option>
                                                            <ng-option value="Retail-Web">Retail-Web </ng-option>
                                                        </ng-select>
                                                    </div>
                                                </div> -->
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>Reservation From Date</label>
                                            <div class="input-group input-group-lg">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                        </fa-icon>
                                                    </span>
                                                </div>
                                                <input [bsConfig]="{
                                                    containerClass: 'theme-primary',
                                                    isAnimated: true,
                                                    customTodayClass: 'custom-today-class'
                                                  }" bsDatepicker formControlName="startdate" class="form-control"
                                                    placeholder="Select date" type="text" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>Reservation To Date</label>
                                            <div class="input-group input-group-lg">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                        </fa-icon>
                                                    </span>
                                                </div>
                                                <input [bsConfig]="{
                                                    containerClass: 'theme-primary',
                                                    isAnimated: true,
                                                    customTodayClass: 'custom-today-class'
                                                  }" bsDatepicker formControlName="enddate" class="form-control"
                                                    placeholder="Select date" type="text" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                          <label>Promo Services</label>
                                          <ng-select [multiple]="true" formControlName="promoservices">
                                            <div *ngFor="let contract of contractIds">
                                              <ng-option [value]="contract.contractID">
                                                {{contract.contractID}}</ng-option>
                                            </div>
                                          </ng-select>
                                        </div>
                                      </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="form-label" for="isCapitalOne">Promotional Contract</label>
                                            <ng-select
                                                    [items]="yesNoOptions"
                                                    bindLabel="label"
                                                    bindValue="value"
                                                    [multiple]="true"
                                                    formControlName="isCapitalOne"
                                            >
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label> Stations</label>
                                                        <ng-select id="station" [multiple]="false" formControlName="stationCode"  placeholder="Select Station" >

                                                            <ng-option *ngFor="let station of stationsList" [value]="station.STATIONID">
                                                                {{station?.STATIONID}} - {{station.AirportName}}
                                                            </ng-option>
                                                        </ng-select>
                                                    </div>
                                                </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label> Customer Bill To (Company Name)</label>
                                            <ng-select id="customer" [multiple]="false" formControlName="customerCompanyName"  placeholder="Select Customer" >

                                                <ng-option *ngFor="let customer of customerList" [value]="customer.COMPANY_NAME">
                                                    {{customer.COMPANY_NAME}}
                                                </ng-option>
                                            </ng-select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group pt-4">
                                            <button class="btn  mt-2 btn-sm btn-block btn-primary btn-square"
                                                type="button" (click)="onFilter(filters_form.value)">
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group pt-4">
                                            <button class="btn btn-sm mt-2  btn-block btn-primary btn-square"
                                                type="button" (click)="onReset()">
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="d-flex justify-content-between pb-3">
                            <div class="search-wrapper">
                                <span class="icon-wrapper text-black">
                                    <fa-icon [icon]="['fas', 'search']"></fa-icon>
                                </span>
                                <input type="text" class="form-control form-control-sm rounded-pill"
                                    placeholder="ResID, Station, Concierge" [ngModelOptions]="{ standalone: true }"
                                    [(ngModel)]="searchText" />
                            </div>
                        </div>
                        <div *ngIf="transactionReport | tsearch: searchText; let filtereddayBeforeData">
                            <div class="table-responsive table-scroll">
                                <table id="report25con"
                                    class="table table-hover table-striped table-bordered text-nowrap mb-3"
                                    [mfData]="filtereddayBeforeData" #mf="mfDataTable" [mfRowsOnPage]="100">
                                    <thead>
                                        <tr>
                                            <th class="bg-white text-left">
                                                <mfDefaultSorter by="RESID">Res ID</mfDefaultSorter>
                                            </th>
                                            <th class="bg-white text-left" style="z-index: 1;">Promotional Contract</th>
                                            <th class="bg-white text-left">Res Type</th>
                                            <th class="bg-white text-left">Res Start Date</th>
                                            <th class="bg-white text-left">Res Creation Date</th>
                                            <th class="bg-white text-left">Station</th>
                                            <th class="bg-white text-left">Currency</th>
                                            <th class="bg-white text-left">Transaction Type</th>
                                            <th class="bg-white text-left">Total </th>
                                            <th class="bg-white text-left">Invoice Receipt ID</th>
                                            <th class="bg-white text-left">Transaction Status</th>
                                            <th class="bg-white text-left">Payment Status</th>
                                            <th class="bg-white text-left">Customer Bill To (Company Name)</th>
                                            <th class="bg-white text-left">Customer Name </th>
                                            <th class="bg-white text-left">Contact Phone</th>
                                            <th class="bg-white text-left">Reference Number</th>
                                            <th class="bg-white text-left">Due Date</th>
                                            <th class="bg-white text-left">Closed Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let greet of mf.data let i=index;">
                                            <td class="text-left">
                                                {{greet.RESID}}
                                            </td>
                                            <td class="text-left">
                                                <div class="custom-checkbox custom-control d-flex" *ngIf="greet?.is_capital_one">
                                                    Capital One
                                                </div>
                                            </td>
                                            <td class="text-left">
                                                {{greet.RES_TYPE}}
                                            </td>
                                            <td class="text-left">
                                                {{getDate(greet.STARTDT)}}
                                            </td>
                                            <td class="text-left ">
                                                <span>{{getDate(greet.RESCREATIONDT)}}
                                                </span>
                                            </td>
                                            <td class="text-left">
                                                {{greet.STATION}}
                                            </td>
                                            <td class="text-left">
                                                {{greet.CURRENCY_FLAG}}
                                            </td>
                                            <td class="text-left ">
                                                <span>{{greet.TRANSACTION_TYPE}}
                                                </span>
                                            </td>
                                            <td class="text-left ">
                                                <span>{{greet.TRANSACTION_TOTAL}}
                                                </span>
                                            </td>
                                            <td class="text-left ">
                                                <span>{{greet.INVOICE_RECEIPT_ID}}
                                                </span>
                                            </td>
                                            <td class="text-left ">
                                                <span>{{greet.TRANSACTION_STATUS}}
                                                </span>
                                            </td>
                                            <td class="text-left ">
                                                <span>{{greet.PAYMENT_STATUS}}
                                                </span>
                                            </td>
                                            <td class="text-left">
                                                {{greet.COMPANY_NAME}}
                                            </td>
                                            <td class="text-left ">
                                                {{greet.CONTACT_NAME}}
                                            </td>
                                            <td class="text-left ">
                                                {{greet.CONTACT_PHONE}}
                                            </td>
                                            <td class="text-left ">
                                                <span
                                                    *ngIf="greet.TRANSACTION_TYPE == 'Credit Card'">{{greet.CCTRANSACTION_NUMBER}}</span>
                                                <span *ngIf="greet.TRANSACTION_TYPE == 'Cheque'">{{greet.CHEQUE_NUMBER}}
                                                </span>
                                            </td>
                                            <td class="text-left ">
                                                <span *ngIf="greet?.DUE_DATE">{{getDate(greet?.DUE_DATE)}}</span>
                                            </td>
                                            <td class="text-left ">
                                                <span
                                                    *ngIf="greet?.PAYMENT_CLOSED_DATE">{{getDate(greet?.PAYMENT_CLOSED_DATE)}}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="11">
                                                <span class="font-weight-bold">Total Records: {{
                                                    filtereddayBeforeData.length
                                                    }}</span> &nbsp;&nbsp;&nbsp;
                                                <mfBootstrapPaginator [rowsOnPageSet]="[100, 200, 300]">
                                                </mfBootstrapPaginator>
                                            </td>
                                            <td colspan="3"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </tab>
</tabset>
<!-- </div>

    </div>
</div> -->



<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>